/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";

import { createComponent } from "@evertrue/et-flux";
import MagicLinkStore from "apps/auth/magic-link-store";
import MagicLinkSource from "apps/auth/magic-link-source";
import { Loading } from "components/et-factories";
import EmailInput from "apps/auth/components/email-input";
import MobileUtils from "utils/mobile-utils";

export default createComponent("MagicLinkRequestController", {
  registerStores() {
    return this.on(MagicLinkStore, () => ({
      email_was_sent: MagicLinkStore.getAuthEmailSent(),
      email_send_failed: MagicLinkStore.getAuthEmailFailed(),
      sending: MagicLinkStore.getSending(),
    }));
  },

  handleSendEmail(email) {
    return MagicLinkSource.sendTokenFromEmail(email);
  },

  render() {
    return (
      <div className="magic-link-request-controller">
        {this.state.sending ? Loading() : undefined}
        {this.state.email_was_sent
          ? <div className="magic-link-request">
          <div className="magic-link-request--header">
            Thank you!
          </div>
          <div className="magic-link-request--image" />
          <div>
            Your access link is on its way!
          </div>
          <div>
            Please check your email.
          </div>
        </div>
          : <div className="magic-link-request is-email-prompt">
          <img
            src={`${MobileUtils.S3_ROUTE}/volunteer-logo-dark-2x.png`}
            alt="Volunteers by EverTrue"
            className="magic-link-request--logo" />
          <div className="magic-link-request--header">
            Welcome!
          </div>
          <div>
            Volunteer by EverTrue is an invite only platform.
          </div>
          <div className="magic-link-request--text">
            {"If you’ve already been invited, enter your email address to receive an access link. "}
          </div>
          <EmailInput
            onSendEmail={this.handleSendEmail}
            emailSendFailed={this.state.email_send_failed} />
        </div>}
        <div className="magic-link-request--bg-image-wrap">
          <img
            src="/images/volunteer-email-img_lg@2x.png"
            className="magic-link-request--bg-image" />
        </div>
      </div>
    );
  },
});
